import React from 'react';
import { FontIcon } from 'material-ui';

export const etoaIcon = (isColoredIcon) => {
  return (
    <FontIcon
      className="tc-icon-etoa"
      color={isColoredIcon ? '#00bcd4' : 'rgba(0, 0, 0, 0.54)'}
      style={{ fontSize: '16px' }}
    />
  );
};

export const ntaIcon = (isColoredIcon) => {
  return (
    <FontIcon
      className="tc-icon-nta"
      color={isColoredIcon ? '#00bcd4' : 'rgba(0, 0, 0, 0.54)'}
      style={{ fontSize: '26px' }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/memberships-text.jsx